import * as uploader from 'ls-common-client/src/uploader';
import client from './client';

const instance = uploader.create(client);

export default instance;
